import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ODataService } from 'src/app/core/services/odata.service';
import { CustomerMetrics } from 'src/app/core/models/entities';

@Injectable({ providedIn: null })
export class CustomerMetricsDetailsService extends ODataService<CustomerMetrics> {
  private field = 'created_at';

  constructor() {
    super(inject(HttpClient), '');
    this.state = {
      skip: 0,
      take: 10,
      sort: [{ field: this.field, dir: 'desc' }],
      filter: {
        logic: 'and',
        filters: [],
      },
    };
  }

}